export const ProblemType = {
  memberAlreadyInAnotherGroup: 'errors.group.memberAlreadyInAnother',
  submissionAlreadyFinalized: 'errors.group.alreadyFinalized',
  sessionCodeInvalid: 'errors.auth.sessionCode.invalid',
  sessionCodeUserNotInClass: 'errors.auth.sessionCode.userNotInClass',
} as const;
